// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VZelnm8hJsbkKPk1DVmA{border:1px solid rgba(0,0,0,0)}.oVF2yFEVRWaRb2VFxQM5{margin-top:12px}`, "",{"version":3,"sources":["webpack://./src/pages/Assets/pages/components/RevenueBreakdown/components/LicensingHistoryFeature/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,8BAAA,CACF,sBACE,eAAA","sourcesContent":[".revenueHistoryContainer\n  border: 1px solid transparent\n.tableContainer\n  margin-top: 12px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"revenueHistoryContainer": `VZelnm8hJsbkKPk1DVmA`,
	"tableContainer": `oVF2yFEVRWaRb2VFxQM5`
};
export default ___CSS_LOADER_EXPORT___;
